export default __webpack_public_path__ + "static/media/default-user.98da796f.svg";